
const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_PROVIDER':
      return { ...state, ...action.current };
    default:
      return state;
  }
};
